define('uikit/modules/pagination',['require','exports','module','underscore','marionette','../helper/browser','../collections/container','../mixins/component.mixin','../channel','./menu','../templates'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var browser        = require('../helper/browser');
  var ContainerView  = require('../collections/container');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel        = require('../channel');
  var Menu           = require('./menu');
  var Templates      = require('../templates');

  var Pagination = Menu.extend({
 
    options: _.extend({}, Menu.prototype.options,{
      totalPages     : 20,
      currentPage    : 1,
      pageShowAmount : 5,
      alwaysShowEnds : false
    }),

    initialize: function(options) {
      // Force pagination enabled
      ContainerView.prototype.initialize.apply(this, arguments);
      options.pagination = true;
      this.on("change:totalPages change:currentPage change:pageShowAmount change:alwaysShowEnds", this.updatePaginationItems);
    },

    onFirstRender: function() {
      this.updatePaginationItems();
    },

    _getCurrentPageRange: function() {
      var current = this.getOption('currentPage'),
          total   = this.getOption('totalPages'),
          showAmt = this.getOption('pageShowAmount'),
          range   = [],
          start   = current - Math.floor(showAmt/2); // center the current page

      // does start + showAmt overflow?  
      if (start + (showAmt-1) > total) {
        start -= (start + (showAmt-1)) - total;
      }
      // did we underflow?
      if (start < 1) { 
        start = 1;
      }
      // start looping from start value and fill up our range until 
      // we crash into the total or we show the showAmt
      var i = start;
      while (i <= total &&  i - start < showAmt) {
        range.push(i)
        i++;
      }
      return range;

    },

    onChildviewRender: function(view) {
      if (browser.isIE() == '9') {
        view.$el.css({
          'padding-left'  : '0px',
          'padding-right' : '0px'
        })
      }
    },

    onChildviewPress: function(view) {
      if (view == this._leftArrow && this.currentPage > 1) {
        this.currentPage--;
      } else if (view == this._rightArrow && this.currentPage < this.totalPages) {
        this.currentPage++;
      } else if (view.text) {
        this.currentPage = Number(view.text);
      }
    },

    updatePaginationItems: function() {
      var current   = this.getOption('currentPage'),
          total     = this.getOption('totalPages'),
          showEnds  = this.getOption('alwaysShowEnds'),
          pageRange = this._getCurrentPageRange(),
          oldItems  = this._views.slice();
      
      function getNextMenuItem() {
        var item = null;
        if (oldItems.length) {
          // We have existing menu items we can recycle, lets return that
          item = oldItems.shift().view;
        } else {
          // We've run out of already created items, start making new ones
          // I want the menu items to look clickable, so I'm going to use
          // an 'a' tag
          var newItem = new Menu.Item({tagName: 'a'});
          this.add(newItem, { destroyOnRemove: true });
          item = newItem;
        }
        // Reset properties on items so that they all start out the same.
        // this is important if they are being recycled.
        item.icon     = null;
        item.text     = '';
        item.disabled = false;
        item.active   = false;
        return item;
      };

      getNextMenuItem = _.bind(getNextMenuItem,this);

      // Determine whether or not to disable the left arrow
      this._leftArrow = getNextMenuItem();
      this._leftArrow.icon = "left arrow";
      if (current <= 1 || total == 0) {
        this._leftArrow.disabled = true;
      }

      // Determine whether or not to force show the first page
      // This is dependent on whether or not the first page is
      // at the start of the given page set and whether or not 
      // we should show ends
      if (total > 0 && pageRange[0] != 1 && showEnds) {
        getNextMenuItem().text = "1";
        if (pageRange[0] != 2) { 
          // Only show ellipsis if we are skipping 
          var ellipsis = getNextMenuItem();
          ellipsis.text = "...";
          ellipsis.disabled = true;
        }
      }

      // Show an item for each page
      for (var i = 0, len = pageRange.length, item; i < len; i++) {
        var p = getNextMenuItem();
        p.text = pageRange[i];
        p.active = current == pageRange[i];
      }

      // Determine whether or not to force show the last page
      // This is dependent on whether or not the first page is
      // at the start of the given page set and whether or not 
      // we should show ends
      if (total > 0 && pageRange[pageRange.length-1] != total && showEnds) {
        if (pageRange[pageRange.length-1] != total-1) {
          //only show ellipsis if we are skipping
          var ellipsis = getNextMenuItem();
          ellipsis.text = "...";
          ellipsis.disabled = true;
        }
        getNextMenuItem().text = total;
      }

      // Determine whether or not to disable the right arrow
      this._rightArrow = getNextMenuItem();
      this._rightArrow.icon = "right arrow";
      if (current >= total) {
        this._rightArrow.disabled = true;
      }

      while (oldItems.length) {
        var old = oldItems.pop().view;
        this.removeView(old);
      }

    }


  });

  channel.reply('pagination', function() {
    return Pagination;
  });

 
  module.exports = Pagination;
});
